import Slider from "@mui/material/Slider";
import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router";
import {useForm} from "react-hook-form";
import i18n from '../../i18n.js'

export default function BusinessFilters(props){

    const {setResetFormCookie, manualQuotationPrice, setManualQuotationPrice, infoFetch,  businessCategories, businessTypes, maxManualQuotationPrice, minManualQuotationPrice, marketplaceTypeSelected, setMarketplaceTypeSelected, categoryFilterSelected, setCategoryFilterSelected, setManualQuotationPriceFilterSelected, language, setCurrentPageSelected, setIsSubmitted, setSearch, setCountrySelected, manualQuotationPriceFilterSelected, intermediationFilterSelected, setIntermediationFilterSelected} = (props) = props;
    
    const navigate = useNavigate();

    const {register ,setValue ,handleSubmit} = useForm();

    const [resetSlider, setResetSlider]= useState(false)
    const [typeFilter, setTypeFilter] = useState(marketplaceTypeSelected)
    const [categoryFilter, setCategoryFilter] = useState(categoryFilterSelected)
    const [intermediationFilter, setIntermediationFilter] = useState(intermediationFilterSelected)

    let marks = [
        {value: minManualQuotationPrice ?? 0,
            label: minManualQuotationPrice ?? 0},
        {value: maxManualQuotationPrice ?? 0,
            label: maxManualQuotationPrice ?? 0}
    ];

    useEffect(() => {
        if(typeFilter !== undefined){
            setValue('businessType', typeFilter);
        }

        if(categoryFilter !== undefined){
            setValue('businessCategory', categoryFilter);
        }

        if (manualQuotationPriceFilterSelected === '*') {
            setValue('manualQuotationPriceSlider', maxManualQuotationPrice)
        } else {
            setValue('manualQuotationPriceSlider', manualQuotationPriceFilterSelected)
        }
        console.log(intermediationFilter)
        if(intermediationFilter !== undefined){
            setValue('businessIntermediation', intermediationFilter);
        }
    }, [infoFetch, typeFilter, categoryFilterSelected, manualQuotationPriceFilterSelected, intermediationFilterSelected]);

    const resetFilters = () => {
        setValue('businessType', '*');
        setValue('businessCategory', '*');
        setValue('businessIntermediation', '*');
        setValue('manualQuotationPriceSlider', maxManualQuotationPrice)
        resetFilterCookies()
        setCategoryFilter('*')
        setTypeFilter('*')
        setIntermediationFilter('*')
        navigate("/negocios-disponibles");
    }

    const resetFilterCookies = () => {
        setMarketplaceTypeSelected('*');
        setCategoryFilterSelected('*');
        setIntermediationFilterSelected('*');
        setManualQuotationPriceFilterSelected('*');
        setCurrentPageSelected(1);
        setCountrySelected('*');
        setSearch('*');
        setManualQuotationPrice(maxManualQuotationPrice);
        setResetFormCookie(true)
    }

    /**
     * Populates business categories select
    */
    const forCategories = !businessCategories? [] : businessCategories.map((bc, index) =>
        (
            <option value={bc.id} key={index}>{language==="es"?bc.name_es:bc.name_pt}</option>
        )
    );

    /**
     * Populates business types select
        */
    const forTypes = !businessTypes? [] : businessTypes.map((bt, index) =>
        (
            <option value={bt.id} key={index}>{language==="es"?bt.name_es:bt.name_pt}</option>
        )
    );

    /**
     * Gets inputs values on change ans sets each const state
     * @param event from slider change
     */
    const getSliderValue = (event) =>{
        setManualQuotationPrice(event.target.value);
     }

       /**
     * Gets inputs values and sends them to parent component BusinessList
     * @param event from submit button
     */
    const onSubmit = (data) => {
        if(resetSlider){
            setManualQuotationPriceFilterSelected('*')
            setResetSlider(false)
        } else {
            setManualQuotationPriceFilterSelected(manualQuotationPrice)
        }

        setMarketplaceTypeSelected(typeFilter)
        setCategoryFilterSelected(categoryFilter)
        setIntermediationFilterSelected(intermediationFilter)
        setCurrentPageSelected(1)
        setIsSubmitted(true);
    }

    const handleChangeType = (value) => {
        setTypeFilter(value);
        setResetSlider(true)
    }

    const handleChangeCategory = (value) => {
        setCategoryFilter(value);
        setResetSlider(true)
    }

    const handleChangeIntermediation = (value) => {
        setIntermediationFilter(value);
        setResetSlider(true)
    }

    return(
            <div className="filters">
                <div className="filters-form shadow p-4">
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <fieldset>
                            <p className="label-element">{i18n.t('business.filters.label1')}</p>
                            <select className="input-info"
                                    name="businessType"
                                    disabled = {!infoFetch }
                                    {...register("businessType")}
                                    onChange={(event)=>handleChangeType(event.target.value)}
                            >
                                <option value="*">Todos</option>
                                {
                                    //TODO que traiga de DB las options en idioma correspondiente
                                    forTypes
                                }
                            </select>
                        </fieldset>

                        <fieldset>
                            <p className="label-element">{i18n.t('business.filters.label2')}</p>
                            <select className="input-info"
                                    name="businessCategory"
                                    disabled = {!infoFetch}
                                    {...register("businessCategory")}
                                    onChange={(event)=>handleChangeCategory(event.target.value)}
                            >
                                <option value="*">Todos</option>
                                {
                                    //TODO que traiga de DB las options en idioma correspondiente
                                    forCategories
                                }
                                </select>
                        </fieldset>

                        <fieldset>
                            <p className="label-element">{i18n.t('business.filters.label4.title')}</p>
                            <select className="input-info"
                                    name="businessIntermediation"
                                    disabled = {!infoFetch }
                                    {...register("businessIntermediation")}
                                    onChange={(event)=>handleChangeIntermediation(event.target.value)}
                            >
                                <option value="*">Todos</option>
                                <option value="0">{i18n.t('business.filters.label4.options.without')}</option>
                                <option value="1">{i18n.t('business.filters.label4.options.with')}</option>
                            </select>
                        </fieldset>

                        <fieldset className={"range-fieldset"}>
                            <p className="label-element">{i18n.t('business.filters.label3')}</p>


                            <Slider
                                value={manualQuotationPrice}
                                {...register("manualQuotationPriceSlider")}
                                name={"manualQuotationPriceSlider"}
                                key={maxManualQuotationPrice+minManualQuotationPrice}
                                aria-label="Slider"
                                defaultValue={0}
                                step={1}
                                min={minManualQuotationPrice}
                                max={maxManualQuotationPrice}
                                valueLabelDisplay="on"
                                marks={marks}
                                onChange={(e) => getSliderValue(e)}
                                disabled = {!infoFetch}
                            />

                        </fieldset>

                        <div className={"submit-filters"}>
                            <input className="btn btn-outline-primary g-action-button rounded-pill w-100"
                                    type="submit"
                                    value={i18n.t('blog.filters.apply')}
                                    disabled = {!infoFetch}
                            />
                        </div>
                    </form>

                    <div onClick={resetFilters} className={"text-center"}>
                        <button
                            className="fix-button-link btn w-100 btn-outline-primary rounded-pill px-4 g-action-button-outline"
                            disabled = {!infoFetch}
                        >{i18n.t('blog.filters.reset')}</button>
                    </div>
                </div>
            </div>
    )
}